import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axiosClient from '../AxiosClient';
import '../Assets/Css/HomeCss/CustomerLove.css';

// Keeps scrolling smoothly on its own and pauses while the cursor is over a review
const sliderSettings = (count) => ({
    arrows: false,
    dots: false,
    infinite: count > 3,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: "linear",
    pauseOnHover: true,
    swipeToSlide: true,
    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, infinite: count > 2 } },
        { breakpoint: 640, settings: { slidesToShow: 1, infinite: count > 1 } },
    ],
});

const Stars = ({ rating }) => (
    <div className="review-stars" aria-label={`${rating} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((n) => (
            <i key={n} className={`fa-solid fa-star ${n <= rating ? "filled" : ""}`}></i>
        ))}
    </div>
);

const CustomerLove = () => {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        axiosClient
            .get('/reviews/latest')
            .then((res) => setReviews(Array.isArray(res.data) ? res.data : []))
            .catch((err) => console.log(err));
    }, []);

    // Only real patient reviews are shown; the section stays hidden until there are some
    if (reviews.length === 0) return null;

    return (
        <section className="customer-love">
            <div className="container">
                <h2>What Our Patients Say</h2>
                <Slider {...sliderSettings(reviews.length)}>
                    {reviews.map((review) => (
                        <div key={review.id} className="px-2 h-full">
                            <div className="testimonial">
                                <Stars rating={review.rating} />
                                <p>"{review.comments}"</p>
                                <h4>{review.patient_name}</h4>
                                {review.doctor_name && (
                                    <span className="customer-position">Patient of {review.doctor_name}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default CustomerLove;
